import './FilesHeader.scss';

export { default } from './FilesHeader';
